module.exports = __webpack_public_path__ + "static/logo Koncept Kultura(1)-2e91d458f7e0e6e8974c9ef599e92ec8.png";